export default "__VITE_ASSET__a8bd18fa__"